import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';

import { IconInfo } from '@assets/icons';
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import { useGetOrchestratorsQuery } from '../store/services/getOrchestrators';
import { getSelectedAlias } from '../store/slices/domainOrchestratorPricingCommittee.slice';

export const ProcessStatusCountsInfo = ({ status }: { status: string }) => {
  const country = useSelector(getCountry);
  const workflowAlias = useSelector(getSelectedAlias);
  const { data } = useGetOrchestratorsQuery(
    country
      ? { country, status, workflow_alias: workflowAlias || undefined }
      : skipToken
  );

  const counts = useMemo(() => {
    const map: Record<string, number> = {};
    data?.forEach(o => {
      o.workflow_steps.forEach(ws => {
        if (ws.status === status) {
          map[ws.name] = (map[ws.name] ?? 0) + 1;
        }
      });
    });
    return map;
  }, [data, status]);

  const entries = Object.entries(counts).filter(([, c]) => c > 0);
  if (entries.length === 0) return null;

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Tooltip id={`tooltip-${status}`}>
          {entries.map(([name, count]) => (
            <div key={name}>
              ({count}) {name}
            </div>
          ))}
        </Tooltip>
      }
    >
      <span
        data-testid={`process-info-${status}`}
        style={{ cursor: 'pointer' }}
      >
        <IconInfo fill="#6c757d" width="16" height="16" />
      </span>
    </OverlayTrigger>
  );
};
